import { useQuery } from "react-query";
import {
  getMappedUnmappedProducts,
  getMarketPlaceConnections,
  getMarketPlaceLumiProducts,
  getMarketPlaceProducts,
  getMarketPlaceStores,
  getStoresMappingList,
} from "../../../services/marketplace";

export const useGetMarketPlaceConnections = () => {
  return useQuery(["marketPlaceConnections"], () =>
    getMarketPlaceConnections().then((res) => res?.data?.data),
  );
};

export const useGetStoresMappingList = ({ isEnabled = true, queries = "" }) => {
  return useQuery(
    ["storesMappingList", queries],
    () => getStoresMappingList(queries).then((res) => res?.data),
    {
      enabled: isEnabled,
    },
  );
};

export const useGetMarketPlaceStores = ({ isEnabled = true, queries = "" }) => {
  return useQuery(
    ["marketPlaceStores", queries],
    () => getMarketPlaceStores(queries).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetMarketPlaceProducts = ({
  isEnabled = true,
  queries = "",
}) => {
  return useQuery(
    ["marketPlaceProducts", queries],
    () => getMarketPlaceProducts(queries).then((res) => res?.data?.data),
    {
      enabled: isEnabled,
    },
  );
};

export const useGetMarketPlaceLumiProducts = ({
  isEnabled = true,
  queries = "",
}) => {
  return useQuery(
    ["marketPlaceLumiProducts", queries],
    () => getMarketPlaceLumiProducts(queries).then((res) => res?.data?.data),
    {
      enabled: isEnabled,
    },
  );
};

export const useGetMappedUnmappedProducts = ({
  isEnabled = true,
  queries = "",
}) => {
  return useQuery(
    ["mappedUnmappedProducts", queries],
    () => getMappedUnmappedProducts(queries).then((res) => res?.data?.data),
    {
      enabled: isEnabled,
    },
  );
};
